import Image from "next/legacy/image";

import Markdown from "components/markdown/markdown";
import type { ContentSubscriptionLevelType } from "lib/types/rankings";
import { imageLoader } from "utils";

import ContentLabel from "./contentLabel";

type RankingTeaserProps = {
  title: string;
  contentSubscriptionLevel?: ContentSubscriptionLevelType;
  indexPageDescription: string;
  urlSuffix: string;
  thumbnailImage: string;
  className?: string;
};

const RankingTeaser = ({
  title,
  indexPageDescription,
  urlSuffix,
  thumbnailImage,
  contentSubscriptionLevel,
  className,
}: RankingTeaserProps) => {
  const isPaidContent =
    contentSubscriptionLevel && contentSubscriptionLevel !== "is_free";

  return (
    <div className={className}>
      <a href={"/rankings/" + urlSuffix} className="group block">
        <div className="relative flex overflow-hidden">
          <div className="block h-full w-full">
            <Image
              className="absolute bg-gray-100 object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
              loader={imageLoader}
              src={thumbnailImage}
              width={344}
              height={194}
              quality={50}
              layout="responsive"
              sizes={"min(50vw, 344px)"}
              alt={title}
            />
          </div>
          {isPaidContent ? (
            <div className="absolute bottom-0 left-0">
              <ContentLabel
                contentSubscriptionLevel={contentSubscriptionLevel}
              />
            </div>
          ) : null}
        </div>

        <div className="transition-colors duration-300 group-hover:text-cerise">
          <p className="mt-xs font-bold text-sm leading-snug md:mt-md md:text-base">
            {title}
          </p>
          <Markdown
            className="mt-sm hidden text-xs md:block"
            text={indexPageDescription}
          />
        </div>
      </a>
    </div>
  );
};

export default RankingTeaser;
